module.exports = combineObjects: (array) ->
  combinedObject = {}

  for object in array
    for property, value of object
      if combinedObject.hasOwnProperty(property)
        if Array.isArray(combinedObject[property])
          combinedObject[property].push(value)
        else
          combinedObject[property] = [combinedObject[property], value]
      else
        combinedObject[property] = value

  for property, value of combinedObject
    if Array.isArray(value)
      trueValue = value.find((val) -> val is true)
      combinedObject[property] = if trueValue? then trueValue else false

  combinedObject